<template>
  <div class="container max-w-6xl">
    <div class="text-center font-bold text-2xl">
        Tin tức & khuyến mãi
    </div>
    <div class="mt-3">
        <!-- <vue-glide v-if="data.length > 0" class=" slide-home  " :breakpoints="breakpoints" :bound="true" type="slide" :gap="12" :peek="{ before: 0, after: 50 }" v-model="active">
            <vue-glide-slide
            v-for="i in data"
            :key="i.id + perView">
                
            </vue-glide-slide>
        </vue-glide> -->

        <div class="grid md:grid-cols-4 md:gap-4">
            <div v-for="i in data" :key="i.id" class="bg-white rounded-lg">
                <div class=" cursor-pointer h-40">
                    <img class="rounded-t-lg" style="height: 100%; width: 100%;" :src="i.image" fluid alt="vclick hot blog image">
                </div>
                <div @click="viewDetail(i.id,i.slug)" class="font-bold-vmain cursor-pointer p-3 h-20 hover:text-red-400">
                    {{ i.name }}

                    <!-- {{i.id}} -->
                </div>
                <div style="color: grey;" class="mgt-10 p-3">
                    
                    <div class=" slide_content">
                        <!-- <div class=""><b-icon icon="folder-fill" scale="1" ></b-icon>  {{ i.category_name }}</div> -->
                        <div class="">
                            <b-icon icon="calendar2-check-fill" scale="1" ></b-icon> {{ i.created_time | toHMDMY }}
                        </div>
                    </div>
                </div>
                <!-- <span class="fw-700 mgt-20">
                    
                </span> -->
            </div>
        </div>
        <div class="text-center mt-4">
            <span @click="fetchDataMore" class="  color-main2 bactive p-2 rounded-2xl hover:text-red-500 hover:border-2 cursor-pointer"><b-icon icon="arrow-down" scale="1" ></b-icon> Xem thêm</span>
        </div>
    </div>

    <b-modal id="bv-modal-news" hide-footer title="Tin tức" size="lg" >
        <div class="d-block text-center">
            <detail-new :data="data_news" />
            <div @click="register" class="bg-active pl-3 pr-3 pt-1 pb-1 text-center  font-bold sticky bottom-0 display-mobile">
                 <div class="bg-main2 text-white p-2 rounded-md w-full"> ĐĂNG KÝ VAY </div>
            </div>
            <div @click="register" class="bg-active p-3 text-center cursor-pointer font-bold rounded-md sticky bottom-0 display-non-mobile">
                Vay ngay cùng FastMoney <span class="bg-main2 text-white p-2 rounded-md"> ĐĂNG KÝ VAY </span>
            </div>
        </div>

    </b-modal>
  </div>
</template>

<script>
import { Glide, GlideSlide } from 'vue-glide-js'
import { getListBlog,getDetailBlog } from '@/api/otp'
import DetailNew from './detailNews.vue'

export default {
    // props: ['data'],
    components: {
        [Glide.name]: Glide,
        [GlideSlide.name]: GlideSlide,
        DetailNew
    },
    data(){
        return{
            active: 0,
            perView: 1,
            data_news: {},
            windowWidth: 0,
            breakpoints: {
                350: {
                    perView: 1
                },
                450: {
                    perView: 1
                },
                800: {
                    perView: 2
                },
                1200: {
                    perView: 3
                },
                1600: {
                    perView: 4
                },
                1920: {
                    perView: 5
                }
            },
            data: [
            ],
            page_size: 4,
            page: 1,
            category_slug: 'tin-tuc-fastmoney',
        }
    },
    methods: {
        register(){
            window.location.href = 'https://vclick.vn'
        },
        viewDetail(id,slug){
            //this.$router.push('/blog/chi-tiet/' +id +'/'+slug)
            //this.$router.push('/'+slug+'.html')
            getDetailBlog({slug: slug}).then(res => {
                this.data_news = res.data
                this.$bvModal.show('bv-modal-news')	
                //this.tags = res.data.tags
            })
        },
        fetchNews(){
            getDetailBlog({slug: this.$route.params.slug}).then(res => {
                this.data = res.data
                this.tags = res.data.tags
            })
        },
        fetchDataMore(){
            this.page_size += 4
            this.fetchData()
        },
        fetchData(){
            getListBlog({
                page: parseInt(this.page),
                page_size: this.page_size,
                category_slug: this.category_slug,
                partner: 'fastmoney'
            }).then(res => {
                this.data = res.data
            })
        },
        getWindowWidth(event) {
            this.windowWidth = document.documentElement.clientWidth;
            console.log(this.windowWidth)
            if(this.windowWidth > 1200){
                this.perView = 4
            } else if(this.windowWidth > 900) {
                this.perView = 3
            } else if(this.windowWidth > 600) {
                this.perView = 2
            } else {
                this.perView = 1
            }
            console.log(this.perView,this.active)
        },
    },
    created(){
        this.fetchData()
    },
    mounted() {
        // this.$nextTick(function() {
        //     window.addEventListener('resize', this.getWindowWidth);
        //     //Init
        //     this.getWindowWidth()
        // })

    },
    beforeDestroy() {
        //window.removeEventListener('resize', this.getWindowWidth);
    }
    //mounted(){
        // screen.addEventListener("resize", ()=> {
        //     console.log('ok')
        //     if(screen.width > 1200){
        //         this.perView = 4
        //     } else if(screen.width > 900) {
        //         this.perView = 3
        //     } else if(screen.width > 600) {
        //         this.perView = 2
        //     } else 
        //         this.perView = 1
        // });
    //}
}
</script>

<style>
.title_slide {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 133%;
    margin-bottom: 15px;
}
.image_slide img {
    width: 96%;
    max-height: 200px;
}
.slide_title {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: -0.03em;
    color: #34404B;
    margin-top: 15px;
}
.slide_content {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 142%;
    letter-spacing: -0.03em;
    color: #9AA0A5;
    margin-top: 15px;
    width: 96%;
}
.slide_content .time_format {
    text-align: right;
}

.slide-home {
    width: 100vw;
    /* max-width: 100% !important; */
}

.glide__slide {
    /* min-width: 300px; */
    /* margin-left: 0px !important;
    margin-right: 0px !important; */
    /* max-width: 350px; */
}

@media screen and (max-width: 640px) {
  .slide-home {
    width: 100%;
        /* max-width: 100% !important; */
    }

    .slide_header {
        padding-right: 0 !important;
    }
}
</style>


</style>